import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../messages';
import { transformAriToId } from '@atlassian/search-common';
import { GenericIconRenderer } from './content-icon-renderer';
export var quickFindConfluenceSpaceMapper = function quickFindConfluenceSpaceMapper(_ref) {
  var item = _ref.node;
  return {
    id: transformAriToId((item === null || item === void 0 ? void 0 : item.id) || '', (item === null || item === void 0 ? void 0 : item.type) || ''),
    title: (item === null || item === void 0 ? void 0 : item.title) || '',
    meta: /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_confluence_space),
    url: (item === null || item === void 0 ? void 0 : item.url) || '',
    type: 'confluence space',
    containerId: item === null || item === void 0 ? void 0 : item.id,
    icon: GenericIconRenderer({
      iconUrl: "/wiki".concat((item === null || item === void 0 ? void 0 : item.iconPath) || ''),
      size: 'small'
    })
  };
};